module.exports = __webpack_public_path__ + "static/media/wifi-login.91eb768f.png";